<template>
  <div style="height: 100%;width: 100%">
    <div v-if="urlShow === 1" class="rongyi-bg">
      <div class="rongyi-login">
        <div class="rongyi-title"><span style="font-family: CustomFont;font-size: 32px;color: #1a1a1a;">欢迎登录</span></div>
        <div style="height: 30px;font-size: 16px;color: #767676;font-weight: 400;font-family: Source Han Sans, Source Han Sans;">荣逸集团智慧养老综合服务平台</div>
        <div class="rongyi-red-hint"></div>
        <div class="rongyi-line-inpt" :style="{border: userB ? '1px solid #3B8AFF' : ''}">
          <div class="rongyi-icon"><img src="../assets/navbar/sign_icon_number.png"></div>
          <div class="rongyi-inpt">
            <input class="input" style="width: 100%;color: black"
                   type="text" :placeholder="isShowPhone ? '手机号' : '用户名'"
                   @focus="show1" @blur="showUser()"
                   v-model="loginForm.username"/>
          </div>
        </div>
        <div class="rongyi-red-hint">{{hintsUser}}</div>
        <div class="rongyi-line-inpt" :style="{border: pawB ? '1px solid #3B8AFF' : ''}">
          <div class="rongyi-icon"><img src="../assets/navbar/sign_icon_password.png"></div>
          <div class="rongyi-inpt">
            <input class="input" style="width: 100%;color: black"
                   :type="isShowPhone ? 'text' : 'password'"
                   :placeholder="isShowPhone ? '验证码' : '账号密码'"
                   @focus="show2" @blur="showPass()"
                   v-model="loginForm.password"/>
          </div>
        </div>
        <div class="rongyi-red-hint">{{hintsPass}}</div>
        <div class="rongyi-send-b" @click="loginCommit()"><span>登录</span></div>
      </div>
    </div>
    <div  v-else :class="evenNumber ? 'login' : 'login1'">
      <div v-if="evenNumber" class="login-box">
        <div style="height: 130px;text-align: center">
          <span v-if="scene === 0" style="font-family: CustomFont;font-size: 48px;color: #1684fc;letter-spacing: 8px">上海慰宁健康<br>管理有限公司</span>
          <div v-else-if="scene === 2" style="padding-top: 40px"><span style="font-family: CustomFont;font-size: 44px;color: #1684fc">蚌山区智慧养老中心</span></div>
          <div v-else style="padding-top: 40px"><span style="font-family: CustomFont;font-size: 48px;color: #1684fc">物联智慧养老系统</span></div>
        </div>
        <div class="line-inpt">
          <div class="img-login-left">
            <img src="../assets/navbar/sign_icon_number.png">
          </div>
          <div class="text-login-right">
            <input class="input" style="width: 100%;color: black"
                   type="text" :placeholder="isShowPhone ? '手机号' : '用户名'"
                   @focus="show1" @blur="showUser()"
                   v-model="loginForm.username"/>
          </div>
        </div>
        <div style="width:380px;height: 30px;text-align: left;margin: auto">
          <span style="color: red;">{{hintsUser}}</span>
        </div>
        <div class="line-inpt">
          <div class="img-login-left">
            <img src="../assets/navbar/sign_icon_password.png">
          </div>
          <div class="text-login-right">
            <input class="input" style="width: 100%;color: black"
                   :type="isShowPhone ? 'text' : 'password'"
                   :placeholder="isShowPhone ? '验证码' : '账号密码'"
                   @focus="show2" @blur="showPass()"
                   v-model="loginForm.password"/>
          </div>
        </div>
        <div style="width:380px;height: 30px;text-align: left;margin: auto">
          <span style="color: red;">{{hintsPass}}</span>
        </div>
        <div v-if="loginActive" class="login-btn-commit" @click="loginCommit()"><span>点 击 登 录</span></div>
        <div v-else class="login-btn-commit1"><span>正在登录中...</span></div>
      </div>
      <div v-else>
        <div class="login-box1">
          <el-row style="height: 100%">
            <el-col :span="12" style="height: 100%;overflow: hidden;border-radius: 20px 0 0 20px">
              <img src="../assets/navbar/img_left.png" style="width: 100%">
            </el-col>
            <el-col :span="12" style="height: 100%">
              <div class="right-login">
                <div style="height: 130px;text-align: center">
                  <span v-if="scene === 0" style="font-family: CustomFont;font-size: 48px;color: #40e3ff;letter-spacing: 8px">上海慰宁健康<br>管理有限公司</span>
                  <div v-else-if="scene === 2" style="padding-top: 40px"><span style="font-family: CustomFont;font-size: 44px;color: #40e3ff;">蚌山区智慧养老中心</span></div>
                  <div v-else style="padding-top: 40px"><span style="font-family: CustomFont;font-size: 48px;color: #40e3ff;">物联智慧养老系统</span></div>
                </div>
                <div class="line-inpt1">
                  <div class="img-login-left">
                    <img src="../assets/navbar/icon_people.png">
                  </div>
                  <div class="text-login-right">
                    <input class="input" style="width: 100%;color: black"
                           type="text" :placeholder="isShowPhone ? '手机号' : '用户名'"
                           @focus="show1" @blur="showUser()"
                           v-model="loginForm.username"/>
                  </div>
                </div>
                <div style="width:380px;height: 30px;text-align: left;margin: auto">
                  <span style="color: red;">{{hintsUser}}</span>
                </div>
                <div class="line-inpt1">
                  <div class="img-login-left">
                    <img src="../assets/navbar/icon_passwork.png">
                  </div>
                  <div class="text-login-right">
                    <input class="input" style="width: 100%;color: black"
                           :type="isShowPhone ? 'text' : 'password'"
                           :placeholder="isShowPhone ? '验证码' : '账号密码'"
                           @focus="show2" @blur="showPass()"
                           v-model="loginForm.password"/>
                  </div>
                </div>
                <div style="width:380px;height: 30px;text-align: left;margin: auto">
                  <span style="color: red;">{{hintsPass}}</span>
                </div>
                <div v-if="loginActive" class="login-btn-commit11" @click="loginCommit()">
                  <span>点 击 登 录</span>
                </div>
                <div v-else class="login-btn-commit111">
                  <span>正在登录中...</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="open-url" v-if="hostUrl === 'jiaold.com' || hostUrl === 'www.jiaold.com'" @click="openBlank">
        <span>粤ICP备14101932号-3</span>
      </div>
      <div class="open-url" v-if="hostUrl === 'jiaold.cn' || hostUrl === 'www.jiaold.cn'" @click="openBlank">
        <span>粤ICP备14101932号-4</span>
      </div>
      <div class="open-url" v-if="hostUrl === 'kangnh.com' || hostUrl === 'bengshan.kangnh.com/'" @click="openBlank">
        <span>粤ICP备14101932号-14</span>
      </div>
    </div>
  </div>
</template>

<script>
import {startSub} from '../mq'

export default {
  name: 'login',
  data () {
    return {
      urlShow: 0, // 1、荣逸集团 0、其他
      userB: false,
      pawB: false,
      evenNumber: true,
      loginActive: true,
      showuser: true,
      showpaw: true,
      loginForm: {
        username: '', // superzero  云通测试账号 353537066824230
        password: '' // test7890  123456
      },
      hintsUser: '',
      hintsPass: '',
      isShowPass: true,
      isShowPhone: false,
      scene: 0,
      hostUrl: ''
    }
  },
  created () {
    this.store2.dispatch('other/update_del_alarm', [])
    this.store2.dispatch('other/update_loginout_info', [])
    this.getDayShow()
    console.log(window.location.host)
    this.hostUrl = window.location.host
    let aa = window.location.host
    if (aa === 'newjky.wecare-u.net' || aa === 'newhealth.wecare-u.net' ||
      aa === 'newhealth.wecare-u.net' || aa === 'bengshan.kangnh.com' || aa === 'kangnh.com') { // 上海更改
      this.scene = 0
    } else if (aa === 'bengshan.kangnh.com') { // 上海慰宁的大账户
      this.scene = 2
    } else if (aa === 'jiaold.com' || aa === 'www.jiaold.com' || aa === 'jiaold.cn' || aa === 'www.jiaold.cn') { // 中性域名
      this.scene = 1
    } else { // 本地测试
      this.scene = 0
    }
    if (aa === 'ryhf.jiaold.com') {
      this.urlShow = 1
    } else {
      this.urlShow = 0
    }
    let arr = aa.split(':')
    if (arr[0] === 'localhost') {
      if (this.isShowPhone) {
        this.loginForm.username = '19988880000'
        this.loginForm.password = '068858'
      } else {
        // this.loginForm.username = 'superzero'
        // this.loginForm.password = 'test7890'
      }
    }
    let that = this
    document.onkeydown = function (e) {
      e = window.event || e
      if (that.$route.path === '/' && (e.code === 'Enter' || e.code === 'enter')) { // 验证在登录界面和按得键是回车键enter
        that.loginCommit() // 登录函数
      }
    }
    this.$store.commit('tabs', [])
  },
  methods: {
    openBlank () {
      window.open('https://beian.miit.gov.cn', '_blank')
    },
    getDayShow () {
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      const day = new Date().format('dd')
      let number = day.split('')
      let arr = [1, 3, 5, 7, 9]
      if (arr.indexOf(parseInt(number[1])) > -1) {
        this.evenNumber = true
      } else {
        this.evenNumber = false
      }
      this.$store.commit('set_evenNumber', this.evenNumber)
    },
    show1 () {
      this.showuser = false
      this.userB = true
    },
    showUser () {
      this.showuser = true
      if (this.loginForm.username === '') {
        this.hintsUser = this.isShowPhone ? '请输入手机号' : '请输入用户名'
      } else {
        this.hintsUser = ''
      }
      this.userB = false
    },
    show2 () {
      this.showpaw = false
      this.pawB = true
    },
    showPass () {
      this.showpaw = true
      if (this.loginForm.password === '') {
        this.hintsPass = this.isShowPhone ? '请输入验证码' : '请输入账号密码'
      } else {
        this.hintsPass = ''
      }
      this.pawB = false
    },
    loginCommit () {
      // let vm = this
      if (this.loginForm.username === '') {
        this.hintsUser = this.isShowPhone ? '请输入手机号' : '请输入用户名'
      } else if (this.loginForm.password === '') {
        this.hintsPass = this.isShowPhone ? '请输入验证码' : '请输入账号密码'
      } else {
        if (this.isShowPhone) {
          this.loginPhone()
        } else {
          this.loginUser()
        }
      }
    },
    // 用户名密码登录
    loginUser () {
      let data = {
        username: this.loginForm.username,
        password: this.loginForm.password,
        scene: this.scene
      }

      this.loginActive = false
      this.$store.dispatch('Login', data).then(() => {
        // 客服人员登录sip电话
        if (this.$store.state.user.role === 'csd' && this.$store.state.user.moduletag !== 2) {
          this.$store.dispatch('GetInfo').then(() => {
            this.golobleObject.getCsdSip()
            startSub(this)
          })
        } else {
          startSub(this)
        }
        this.loginActive = true
        this.$store.commit('set_path', true)
        this.$router.push('/home')
      }).catch(() => {
        this.loginActive = true
      })
    },
    // 手机号验证码登录
    loginPhone () {
      let authdata = {
        phone: this.loginForm.username,
        code: this.loginForm.password
      }
      this.loginActive = false
      this.$store.dispatch('LoginAuth', authdata).then(() => {
        let usertypedata = {
          typetag: 4,
          muid: this.$store.state.user.auth.id,
          scene: this.scene
        }
        this.$store.dispatch('LoginSelectusertype', usertypedata).then(() => {
          this.loginActive = true
          startSub(this)
          this.$store.commit('set_path', true)
          this.$router.push('/home')
        })
      }).catch(error => {
        console.log(error)
        this.loginActive = true
      })
    }
  }
}
</script>

<style scoped>
.open-url{
  height: 30px;
  width: 200px;
  text-align: center;
  color: #1a1a1a;
  position: absolute;
  bottom: 30px;
  letter-spacing: 1px;
  left: 50%;
  margin-left: -100px;
  cursor: pointer;
  font-weight: bold;
}
  .input{
    border: none;
    outline: none;
    height: 100%;
    font-size: 18px;
    background: none;
  }
.login{
  width: 100%;
  height: 100%;
  background: url("../assets/navbar/sign_bg.png") no-repeat center;
  background-size: 100% 100%;
}
.login1{
  width: 100%;
  height: 100%;
  background: url("../assets/navbar/bg.png") no-repeat center;
  background-size: 100% 100%;
}
.login-box{
  width: 410px;
  height: 340px;
  position: absolute;
  top: 50%;
  margin-top: -170px;
  left: 10%;
}
.line-inpt{
  margin: auto;
  width: 380px;
  height: 50px;
  border-radius: 25px;
  border: solid 1px #999999;
}
  .line-inpt1{
    border-radius: 10px;
    margin: auto;
    width: 380px;
    height: 50px;
    border: solid 1px #cccccc;
  }
.img-login-left{
  float: left;
  width: 50px;
  line-height: 50px;
  text-align: center;
}
  .img-login-left img{
    width: 24px;
    vertical-align: middle;
  }
.text-login-right{
  float: left;
  width: calc(100% - 52px);
  height: 50px;
}
.login-btn-commit{
  margin: auto;
  width: 380px;
  height: 50px;
  border-radius: 25px;
  background-image: linear-gradient(90deg,
  #3f34db 0%,
  #5280f9 100%);
  color: white;
  cursor: pointer;
  font-size: 24px;
  text-align: center;
  line-height: 50px;
}
  .login-btn-commit11{
    margin: auto;
    width: 380px;
    height: 50px;
    border-radius: 10px;
    background-image: linear-gradient(90deg,
    #00f2f2 0%,
    #00e6e6 58%,
    #00d9d9 100%),
    linear-gradient(
      #3381ff,
      #3381ff);
    background-blend-mode: normal,
    normal;
    box-shadow: 0px 7px 30px 0px
    rgba(51, 255, 255, 0.5);
    color: white;
    cursor: pointer;
    font-size: 24px;
    text-align: center;
    line-height: 50px;
  }
.login-btn-commit1{
  margin: auto;
  width: 380px;
  height: 50px;
  border-radius: 25px;
  background-image: linear-gradient(90deg,
  #999999 0%,
  #cccccc 100%);
  color: white;
  font-size: 24px;
  text-align: center;
  line-height: 50px;
}
  .login-btn-commit111{
    margin: auto;
    width: 380px;
    height: 50px;
    border-radius: 10px;
    background-image: linear-gradient(90deg,
    #999999 0%,
    #cccccc 100%);
    color: white;
    font-size: 24px;
    text-align: center;
    line-height: 50px;
  }
  .login-box1{
    width: 80%;
    height: 66%;
    background-color: #ffffff;
    box-shadow: 0px 7px 27px 0px
    rgba(135, 232, 232, 0.51);
    border-radius: 20px;
    position: absolute;
    top: 17%;
    left: 10%;
  }
  .right-login{
    width: 410px;
    height: 340px;
    position: relative;
    top: 50%;
    margin-top: -170px;
    left: 50%;
    margin-left: -205px;
  }
  /* 荣逸集团 */
.rongyi-bg{
  width: 100%;
  height: 100%;
  background: url("../assets/navbar/rongyi_bg.jpg") no-repeat center;
  background-size: 100% 100%;
}
.rongyi-login{
  width: 420px;
  height: 460px;
  background: #FFFFFF;
  box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.1);
  border-radius: 10px 10px 10px 10px;
  position: absolute;
  top: 50%;
  margin-top: -210px;
  right: 0;
  margin-right: 200px;
  padding: 0 40px;
  box-sizing: border-box;

}
.rongyi-title{
  text-align: left;
  margin-top: 50px;
}
.rongyi-red-hint{
  height: 35px;
  line-height: 30px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #EA0000;
}
.rongyi-line-inpt{
  height: 60px;
  display: flex;
  border-radius: 5px 5px 5px 5px;
  background: #F7F8FA;
  box-sizing: border-box;
}
.rongyi-icon{
  padding: 17px;
}
.rongyi-inpt{
  flex: 1;
  height: 60px;
}
.rongyi-send-g{
  height: 60px;
  line-height: 60px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  text-align: center;
  background: #E0EAFF;
  border-radius: 5px 5px 5px 5px;
  letter-spacing: 5px;
}
.rongyi-send-b{
  height: 60px;
  line-height: 60px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  text-align: center;
  background: #3B8AFF;
  border-radius: 5px 5px 5px 5px;
  cursor: pointer;
  letter-spacing: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue